/**
 * Persistência da preferência de consentimento de cookies (categoria analytics).
 * Guardado em localStorage — é cookie essencial (registro da própria escolha), permitido
 * sem consentimento. Registra versão da política + timestamp para auditoria (cookie §8).
 * Mudança de versão da política força re-perguntar.
 */

export const CONSENT_STORAGE_KEY = 'visualg_cookie_consent'
// Previous choices only disclosed contextual ads, not personalization.
export const CONSENT_POLICY_VERSION = '3.0'

const VALID_VALUES = new Set(['granted', 'denied'])
const canUseStorage = () => typeof localStorage !== 'undefined'

const normalize = (value) => (VALID_VALUES.has(value) ? value : 'unset')

export function readConsent() {
  if (!canUseStorage()) return { analytics: 'unset', advertising: 'unset' }
  try {
    const raw = localStorage.getItem(CONSENT_STORAGE_KEY)
    if (!raw) return { analytics: 'unset', advertising: 'unset' }
    const parsed = JSON.parse(raw)
    if (parsed?.policyVersion !== CONSENT_POLICY_VERSION) return { analytics: 'unset', advertising: 'unset' }
    return { analytics: normalize(parsed?.analytics), advertising: normalize(parsed?.advertising) }
  } catch {
    return { analytics: 'unset', advertising: 'unset' }
  }
}

export function clearConsent() {
  if (!canUseStorage()) return
  try {
    localStorage.removeItem(CONSENT_STORAGE_KEY)
  } catch {
    // storage indisponível — silencioso
  }
}

export function writeConsent(value) {
  if (!canUseStorage()) return
  const analytics = normalize(typeof value === 'string' ? value : value?.analytics)
  const payload = {
    analytics,
    advertising: normalize(typeof value === 'object' ? value?.advertising : readConsent().advertising),
    policyVersion: CONSENT_POLICY_VERSION,
    timestamp: new Date().toISOString(),
  }
  try {
    localStorage.setItem(CONSENT_STORAGE_KEY, JSON.stringify(payload))
  } catch {
    // storage indisponível (modo privado etc) — silencioso
  }
}
